import script from "./ShakyoMessageModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ShakyoMessageModal.vue?vue&type=script&setup=true&lang=js"

import "./ShakyoMessageModal.vue?vue&type=style&index=0&id=86d88d0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-86d88d0e"]])

export default __exports__